module.exports = __webpack_public_path__ + "img/rudiboard.795f02c4.png";